import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldErrorDisplayComponent } from './field-error-display.component';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';

import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FieldErrorDisplayComponent],
  imports: [
    CommonModule,
   
    HttpModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    FieldErrorDisplayComponent
  ]
})
export class FieldErrorDisplayModule { }
